import {ADDITIONAL_CROP_IDS, isObservationalCrop} from '../../../../../shared/utils/cropCatalog'

export const ECONOMIC_CROP_IDS = Object.freeze(['corn', 'soybean', 'wheat', ...ADDITIONAL_CROP_IDS])
const COMMERCIAL_MOISTURE = {corn: '14,5', soybean: '13,5', wheat: '13,5'}

// Fruit, tuber, cane and leaf weights must not be normalized as cereal grain.
export const usesGrainInputs = (crop) => !isObservationalCrop(crop)

export const defaultEconomicMoistureTreatment = (crop = 'corn') => ({
  inputYieldBasis: usesGrainInputs(crop) ? 'as_harvested' : 'not_applicable',
  originalMoistureField: '',
  outputCommercialTargetPercent: COMMERCIAL_MOISTURE[crop] || '',
})

export const nonGrainMoisturePayload = (rawYieldConfirmed) => ({
  inputYieldBasis: 'not_applicable',
  originalMoistureField: null,
  inputCorrectionTargetPercent: null,
  outputCommercialTargetPercent: null,
  rawYieldConfirmed,
  reason: 'crop_not_grain',
})
